const styles = () => ({
  card: {
    // paddingLeft: "20px",
    // paddingBottom: "15px",
    // paddingRight: "20px",
  },
  lowercase: {
    textTransform: "lowercase",
    cursor: "pointer",
  },
  fontWeightBold: {
    fontWeight: "bold",
  },
  fileButtonsText: {
    paddingLeft: "5px",
    textTransform: "lowercase",
    paddingBottom: "3px",
  },
  rightAlign: {
    float: "right",
    padding: 8,
    marginRight: 10,
  },
  reqText: {
    fontStyle: "italic",
    fontWeight: "bold",
  },
  reqTextRed: {
    color: "#ee0000",
    marginLeft: "5px",
  },
  reducedFont: {
    fontSize: "13px",
  },
  formTemplateText: {
    fontSize: "13px",
    textTransform: "upperCase",
  },
  additionalInfo: {
    fontSize: "11px",
    fontStyle: "italic",
  },
  minFont: {
    fontSize: "9px",
  },
  firstReqDocBorder: {
    borderTop: "1px solid black",
    borderBottom: "1px solid black",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  restOfReqDocBorder: {
    borderBottom: "1px solid black",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  firstFileStyle: {
    paddingTop: "10px",
    paddingBottom: "5px",
  },
  restOfFileStyle: {
    paddingBottom: "5px",
  },
  paper: {
    padding: "15px",
    margin: "5px 0px 5px 0px",
  },
});

export default styles;
